<template>
    <div class="form-item">
        <label class="label-caption">
            {{ item.nmcaption }}
            <span v-if="isObrigatorio" class="required">*</span>
        </label>

        <div class="check-group">
            <label
                v-for="opcao in opcoes"
                :key="opcao.value"
                class="check-option"
            >
                <input
                    type="checkbox"
                    class="check-input"
                    :value="opcao.value"
                    :checked="valoresSelecionados.includes(opcao.value)"
                    @change="onChange(opcao.value, $event.target.checked)"
                />

                <span class="check-label">{{ opcao.label }}</span>
            </label>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { opcoesDoItem, parseListaValores } from './docUtils';

const props = defineProps({
    item: {
        type: Object,
        required: true
    },
    opcoesApi: {
        type: Array,
        default: () => []
    }
});

const emit = defineEmits(['update:item']);

const isObrigatorio = computed(() => props.item.ckobrigatorio === 'S');

const opcoes = computed(() => opcoesDoItem(props.item, props.opcoesApi));

const valoresSelecionados = computed(() => {
    return parseListaValores(props.item.resposta_opcoes_cditem || props.item.resposta_opcoes);
});

function onChange(value, checked) {
    let codigos = parseListaValores(props.item.resposta_opcoes_cditem || props.item.resposta_opcoes);

    if (checked && !codigos.includes(value)) codigos.push(value);
    if (!checked) codigos = codigos.filter(v => v !== value);

    const labels = codigos
        .map(codigo => opcoes.value.find(o => o.value === codigo)?.label)
        .filter(Boolean);

    emit('update:item', {
        ...props.item,
        resposta_opcoes: labels.length ? labels.join(';') : null,
        resposta_opcoes_cditem: codigos.length ? codigos.join(';') : null
    });
}
</script>

<style scoped>
.check-group {
    display: flex;
    flex-wrap: wrap;
    gap: 8px 14px;
    align-items: flex-start;
}

.check-option {
    display: inline-flex;
    align-items: flex-start;
    gap: 6px;

    padding: 6px 10px;
    border: 1px solid #d0d0d0;
    border-radius: 4px;
    background: #f9f9f9;

    font-weight: normal;
    line-height: 1.25;
    cursor: pointer;
    max-width: 100%;

    transition: .15s;
}

.check-option:hover {
    background: #eef5f4;
    border-color: #4a827c;
}

.check-option:has(input:checked) {
    background: #dff1ef;
    border-color: #4a827c;
    box-shadow: inset 0 0 0 1px #4a827c;
}

.check-input {
    width: 15px !important;
    height: 15px !important;
    min-height: 15px !important;
    padding: 0;
    margin: 2px 0 0 0;

    flex: 0 0 15px;
    cursor: pointer;
}

.check-label {
    display: inline-block;
    max-width: 100%;
    word-break: break-word;
}

.required {
    color: #b00020;
    margin-left: 3px;
}
</style>